<template>
	<div class="uk-width-expand@m">
		<!-- Add class 'active' for overlay -->
		<div class="bb-options" :class="{'active' : modals_open}">
			<MostPopular v-if="popular_finishes.length > 0"/>
			<CreateOwn @toggle="onToggleVisibility" />
		</div>
		<NextButtons
			prev_route="choose-size"
			next_route="additions" />
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import NextButtons from '../components/NextButtons.vue';
	import MostPopular from '../components/MostPopular.vue';
	import CreateOwn from '../components/CreateOwn.vue';

	export default {
		name : 'wood-finish-view',
		components: {
			MostPopular,
			CreateOwn,
			NextButtons
		},
		data() {
			return {
				modals_open : false
			}
		},
		methods : {
			onToggleVisibility(open){
				this.modals_open = open;
			}
		},
		computed : {
			...mapState({
				popular_finishes: state => state.popular_finishes
			})
		}
	}
</script>